/* WEB-07 (24-oct-2026) · Catálogo en celular.
   1) La barra de arriba se esconde al bajar y vuelve recién al subir ~70 px (el theme la traía de vuelta con 1 px).
   2) Con la vista «Plana», tocar una prenda abre la ficha en el color de la foto (?variant=).
   3) En el cajón de filtros, «Ordenar» pasa a botones redondos arriba de todo. */
// 25-oct: la 6.1 ya no carga --scrollbar-width (la 5.3 sí). Sin eso, con barra de desplazamiento visible,
// la barra de arriba y el contenido de 1.120 px quedan corridos unos píxeles. Se mide igual que la 5.3.
(() => {
  const sb = () => document.documentElement.style.setProperty('--scrollbar-width', Math.max(0, window.innerWidth - (document.body || document.documentElement).clientWidth) + 'px');
  sb(); window.addEventListener('resize', sb, { passive: true }); document.addEventListener('DOMContentLoaded', sb); window.addEventListener('load', sb);
})();
(() => {
  const mq = window.matchMedia('(max-width: 1023px)');
  const UP_TO_SHOW = 70;

  // 1) Barra que vuelve al subir
  const header = document.querySelector('header[is="sticky-header"][data-sticky-type="on-scroll-up"]');
  const section = header && header.closest('.shopify-section');
  if (section) {
    let last = window.scrollY;
    let up = 0;
    const setHidden = (hidden) => section.classList.toggle('w7-hide', hidden);

    const onScroll = () => {
      const y = window.scrollY;
      const dy = y - last;
      last = y;
      if (y < header.offsetHeight + 100) {
        up = 0;
        setHidden(false);
        return;
      }
      if (dy > 0) {
        up = 0;
        setHidden(true);
      }
      else if (dy < 0) {
        up -= dy;
        if (up >= UP_TO_SHOW) setHidden(false);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    mq.addEventListener('change', onScroll);
  }

  // 1b) Compu: la fila filtro + Calce/Plana de la barra flotante aparece solo cuando la de la página ya no se ve (no se duplica)
  const pageRow = document.querySelector('.w7-dk');
  if (pageRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      document.documentElement.classList.toggle('w7-row-out', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(pageRow.closest('.collection__topbar') || pageRow);
  }

  // 2) Plana → la ficha abre en ese color
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || !link.closest('#ProductGridContainer.lifestyle')) return;
    const flat = link.closest('.card')?.querySelector('.w7-flat[data-w7-variant]');
    if (!flat) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('variant', flat.dataset.w7Variant);
    link.href = url.toString();
  }, true);

  // 2b) Calce/Plana (25-oct): hay varios botones (fila de la página, barra flotante, compu) y el theme los maneja
  //     como «interruptor» cada uno por su lado → se desincronizaban al filtrar («toco Calce y no se pone Calce»).
  //     Ahora manda un solo estado: tocar «Calce» = foto con modelo, «Plana» = foto plana, siempre; se guarda y se
  //     aplica a la grilla y a todos los botones (también después de filtrar, cuando el theme re-dibuja).
  const mvKey = () => ((window.theme && theme.settings && theme.settings.themeName) || 'theme') + ':model-view';
  const mvGet = () => { try { return localStorage.getItem(mvKey()) === 'true'; } catch (e) { return false; } };
  const mvApply = (v) => {
    try { localStorage.setItem(mvKey(), String(v)); } catch (e) {}
    const grid = document.getElementById('ProductGridContainer');
    if (grid && grid.classList.contains('lifestyle') !== v) grid.classList.toggle('lifestyle', v);
    document.querySelectorAll('.w7-foto:not(.w7-gen)').forEach((b) => {
      if (b.hasAttribute('open') !== v) { b._open = v; v ? b.setAttribute('open', '') : b.removeAttribute('open'); }
      else b._open = v;
    });
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.w7-foto:not(.w7-gen)');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    // El área tocable del botón es más grande que los textos: se decide por el lado tocado (izquierda Calce, derecha Plana).
    const seg = event.target.closest('.w7-seg');
    const r = btn.getBoundingClientRect();
    mvApply(seg ? seg.dataset.w7 === 'plana' : event.clientX > r.left + r.width / 2);
  }, true);

  // 3) Ordenar en botones (usa el mismo selector del theme, así el filtrado sigue igual). Solo 5 opciones, con nombres cortos.
  const SORT_LABELS = {
    'manual': 'Destacados',
    'best-selling': 'Más vendidos',
    'created-descending': 'Más nuevos',
    'price-ascending': 'Menor precio',
    'price-descending': 'Mayor precio'
  };
  const buildSort = () => {
    mvApply(mvGet());
    ['FacetFormSortBy-sticky', 'FacetFormSortBy-drawer'].forEach(buildSortFor);
    ['FacetDrawerSticky', 'FacetDrawer'].forEach(decorate);
  };

  // 3b) Cajón de filtros como el prototipo: «Filtrar y ordenar», grupos en orden Para quién · Qué buscás · Talle,
  //     botones grandes, y «Borrar» al lado de «Ver resultados». Usa los filtros que ya tiene la tienda.
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  // 25-oct: orden elegido por Alan: Para quién · Qué buscás · Talle · Colores · Precio (Disponibilidad va oculta).
  // Se reconocen por el nombre del filtro (no por la etiqueta): si conviven el viejo y el nuevo, gana el nuevo
  // y el viejo se esconde (Genero → Para quién, Articulo → Qué buscás).
  const GROUPS = [
    { params: ['custom.para_quien', 'custom.genero'], label: 'Para quién', cls: 'w7-g-gen' },
    { params: ['custom.grupo', 'custom.articulo'], label: 'Qué buscás', cls: 'w7-g-que' },
    { params: ['option.talle'], label: 'Talle', cls: 'w7-g-tal' },
    { params: ['custom.familias_color'], label: 'Colores', cls: 'w7-g-col' },
    { params: ['v.price'], label: 'Precio', cls: 'w7-g-pre' },
    { params: ['v.availability'], label: 'Solo mostrar disponibles', cls: 'w7-g-disp' }
  ];

  const SWATCH = {
    'Negro': '#111', 'Blanco': '#f6f6f4', 'Gris': '#8d8f93', 'Beige': '#d8c6a8', 'Marrón': '#6e4a33',
    'Verde': '#2f6b4f', 'Azul': '#3a5fb0', 'Rojo y rosa': 'linear-gradient(135deg,#a3213a 50%,#e99ab0 50%)',
    'Lila y violeta': '#8a6bbf', 'Amarillo y naranja': 'linear-gradient(135deg,#f0c23b 50%,#ee7d2c 50%)'
  };
  // Precio en botones con el precio de TRANSFERENCIA (el filtro de Shopify usa el de lista: lista = transferencia / 0,75).
  const PRICE_CHIPS = [
    { t: 'Hasta $10.000', lte: 10000 },
    { t: '$10.000 a $20.000', gte: 10000, lte: 20000 },
    { t: 'Más de $20.000', gte: 20000 }
  ];
  const lista = (n) => (n == null ? '' : String(Math.round(n / 0.75)));
  const enGenero = /^\/collections\/(mujer|hombre)(\/|$)/.test(location.pathname);
  const extras = (form, d, g) => {
    if (g.cls === 'w7-g-gen' && enGenero) d.hidden = true;
    if (g.cls === 'w7-g-tal') {
      // Talles en orden lógico (Shopify los manda alfabéticos: L, M, S, XL…)
      const ORD = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
      const rank = (v) => { const i = ORD.indexOf(String(v).toUpperCase()); return i >= 0 ? i : 100 + (parseFloat(v) || 0); };
      d.querySelectorAll('.list, ul').forEach((ul) => {
        const items = [...ul.children].filter((li) => li.querySelector('input[name="filter.v.option.talle"]'));
        if (items.length < 2) return;
        const sorted = [...items].sort((a, b) => rank(a.querySelector('input').value) - rank(b.querySelector('input').value));
        if (sorted.some((li, i) => li !== items[i])) sorted.forEach((li) => ul.appendChild(li));
      });
    }
    if (g.cls === 'w7-g-disp') {
      const av = d.querySelector('input[name="filter.v.availability"]');
      if (/^\/collections\/packs(\/|$)/.test(location.pathname)) { d.hidden = true; return; }
      if (av && !av.checked) av.checked = true;
      if (!d.querySelector('.w7-siempre')) {
        const s = document.createElement('small');
        s.className = 'w7-siempre';
        s.textContent = 'Siempre activo: solo ves lo que hay en stock';
        d.appendChild(s);
      }
    }
    if (g.cls === 'w7-g-col') {
      d.querySelectorAll('input[type="checkbox"]').forEach((i) => {
        const lab = d.querySelector(`label[for="${i.id}"]`) || i.closest('label');
        if (!lab || lab.querySelector('.w7-sw')) return;
        const sw = document.createElement('i');
        sw.className = 'w7-sw';
        sw.style.background = SWATCH[i.value] || '#ccc';
        lab.prepend(sw);
      });
    }
    if (g.cls === 'w7-g-pre') {
      const gte = d.querySelector('input[name="filter.v.price.gte"]');
      const lte = d.querySelector('input[name="filter.v.price.lte"]');
      if (!gte || !lte) return;
      const have = d.querySelector('.w7-pchips');
      if (have) {
        have.querySelectorAll('button').forEach((b, k) => {
          const c = PRICE_CHIPS[k];
          const on = String(gte.value === lista(c.gte) && lte.value === lista(c.lte));
          if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
        });
        return;
      }
      const box = document.createElement('div');
      box.className = 'w7-pchips w7-chips';
      PRICE_CHIPS.forEach((c) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = c.t;
        const on = gte.value === lista(c.gte) && lte.value === lista(c.lte);
        b.setAttribute('aria-pressed', String(on));
        b.addEventListener('click', () => {
          const off = b.getAttribute('aria-pressed') === 'true';
          gte.value = off ? '' : lista(c.gte);
          lte.value = off ? '' : lista(c.lte);
          lte.dispatchEvent(new Event('change', { bubbles: true }));
        });
        box.appendChild(b);
      });
      const content = d.querySelector('.details__content');
      if (content) { content.classList.add('w7-pre-hide'); content.before(box); }
    }
  };
  // «Solo mostrar disponibles» siempre prendido: va en cada filtrado, así el talle elegido cruza con el stock real.
  // 25-oct: los packs no tienen stock propio (se arman con prendas sueltas): en Packs no se fuerza «disponibles»
  const esPacks = /^\/collections\/packs(\/|$)/.test(location.pathname);
  if (esPacks) document.documentElement.classList.add('w7-packs');
  const syncStock = (form) => {
    if (esPacks) return;
    const av = form.querySelector('input[name="filter.v.availability"][value="1"]');
    if (!av) return;
    av.checked = true;
  };
  const decorate = (id) => {
    const drawer = document.getElementById(id);
    const form = drawer && drawer.querySelector('form.facet-form');
    if (!form) return;
    // 25-oct: los grupos se reacomodan en cada vuelta (el theme re-dibuja partes del cajón al filtrar); lo demás, una sola vez.
    const first = !form.dataset.w7;
    form.dataset.w7 = '1';
    const t = drawer.querySelector('.drawer__title');
    if (t && t.textContent !== 'Filtrar y ordenar') t.textContent = 'Filtrar y ordenar';
    const sort = form.querySelector('.select-sort-by');
    let after = sort;
    const blocks = [...form.querySelectorAll(':scope > .details')];
    const has = (x, p) => !!x.querySelector(`input[name^="filter."][name*="${p}"]`);
    GROUPS.forEach((g) => {
      const found = g.params.map((p) => blocks.find((x) => has(x, p))).filter(Boolean);
      const d = found[0];
      found.slice(1).forEach((x) => { if (!x.hidden) x.hidden = true; });
      if (!d) return;
      d.classList.add('w7-g', g.cls);
      const lbl = d.querySelector('.details__summary .text-base-xl');
      if (lbl && lbl.firstChild && lbl.firstChild.textContent !== g.label) lbl.firstChild.textContent = g.label;
      if (after) { if (d.previousElementSibling !== after) after.after(d); } else if (form.firstElementChild !== d) form.prepend(d);
      after = d;
      extras(form, d, g);
    });
    if (first) form.addEventListener('change', () => syncStock(form), true);
    const foot = drawer.querySelector('.drawer__sticky');
    if (foot && !foot.querySelector('.w7-borrar')) {
      const clear = document.createElement('a');
      clear.className = 'w7-borrar';
      clear.href = location.pathname;
      clear.textContent = 'Borrar';
      foot.prepend(clear);
    }
  };
  const buildSortFor = (id) => {
    const select = document.getElementById(id);
    if (!select) return;
    const wrap = select.closest('.select-sort-by');
    if (!wrap || wrap.querySelector('.w7-sort')) return;

    const box = document.createElement('div');
    box.className = 'w7-sort';
    box.innerHTML = '<p>Ordenar por</p><div class="w7-chips" role="group" aria-label="Ordenar por"></div>';
    const chips = box.querySelector('.w7-chips');
    Array.from(select.options).forEach((option) => {
      if (!(option.value in SORT_LABELS) && !option.selected) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = SORT_LABELS[option.value] || option.textContent.trim();
      button.setAttribute('aria-pressed', String(option.selected));
      button.addEventListener('click', () => {
        if (select.value === option.value) return;
        select.value = option.value;
        chips.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      chips.appendChild(button);
    });
    wrap.appendChild(box);
  };


  // 4) Paneles propios (menú desde la izquierda, carrito desde la derecha): abrir, cerrar con ✕, tocando afuera, Esc o deslizando
  const panels = {};
  const openPanel = (id) => {
    const root = document.getElementById(id);
    if (!root) return;
    Object.keys(panels).forEach((k) => k !== id && closePanel(k));
    root.hidden = false;
    document.documentElement.classList.add('w7-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('in')));
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    panels[id] = true;
    root.querySelector('[data-w7-close]')?.focus({ preventScroll: true });
    root.dispatchEvent(new CustomEvent('w7:open'));
  };
  const closePanel = (id) => {
    const root = document.getElementById(id);
    if (!root || root.hidden) return;
    root.classList.remove('in');
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    delete panels[id];
    if (!Object.keys(panels).length) document.documentElement.classList.remove('w7-lock');
    setTimeout(() => { if (!root.classList.contains('in')) root.hidden = true; }, 280);
  };
  window.w7Panel = { open: openPanel, close: closePanel };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[aria-controls="W7Menu"], [aria-controls="W7Cart"], [aria-controls="W7Search"]');
    if (opener) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openPanel(opener.getAttribute('aria-controls'));
      return;
    }
    const closer = event.target.closest('[data-w7-close]');
    if (closer) {
      const root = closer.closest('.w7-mo, .w7-co, .w7-so');
      if (root) closePanel(root.id);
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') Object.keys(panels).forEach(closePanel);
  });
  // Deslizar para cerrar: menú hacia la izquierda, carrito hacia la derecha
  document.addEventListener('touchstart', (event) => {
    const sheet = event.target.closest('.w7-mp, .w7-cp');
    if (!sheet) return;
    const dir = sheet.classList.contains('w7-mp') ? -1 : 1;
    const x0 = event.touches[0].clientX;
    const y0 = event.touches[0].clientY;
    let dx = 0;
    let horizontal = null;
    const move = (e) => {
      const mx = e.touches[0].clientX - x0;
      const my = e.touches[0].clientY - y0;
      if (horizontal === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) horizontal = Math.abs(mx) > Math.abs(my);
      if (!horizontal) return;
      dx = mx * dir > 0 ? mx : 0;
      sheet.classList.add('drag');
      sheet.style.transform = `translateX(${dx}px)`;
    };
    const end = () => {
      sheet.classList.remove('drag');
      sheet.style.transform = '';
      if (Math.abs(dx) > 80) closePanel(sheet.closest('.w7-mo, .w7-co').id);
      sheet.removeEventListener('touchmove', move);
      sheet.removeEventListener('touchend', end);
    };
    sheet.addEventListener('touchmove', move, { passive: true });
    sheet.addEventListener('touchend', end);
  }, { passive: true });

  // 5) Menú: interruptor Mujer / Hombre (recuerda la elección)
  const setGen = (gen) => {
    document.querySelectorAll('[data-w7-gen]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.w7Gen === gen)));
    document.querySelectorAll('[data-w7-list]').forEach((l) => { l.hidden = l.dataset.w7List !== gen; });
    try { localStorage.setItem('w7:gen', gen); } catch (e) {}
  };
  document.addEventListener('click', (event) => {
    const b = event.target.closest('[data-w7-gen]');
    if (b) setGen(b.dataset.w7Gen);
  });
  try {
    const saved = localStorage.getItem('w7:gen');
    if (saved && document.querySelector(`[data-w7-gen="${saved}"]`)) setGen(saved);
  } catch (e) {}

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(buildSort, 60);
  });
  const start = () => {
    buildSort();
    const root = document.getElementById('MainContent') || document.body;
    observer.observe(root, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();

  // 25-oct · Compu (≥1200 px): «Filtrar y ordenar» y Calce/Plana suben a la fila del título del catálogo.
  // Son 2 secciones distintas del theme, así que se mide y se sube la fila de botones lo justo (sin mover nodos).
  // 26-oct: foto plana sin repetir color con la tarjeta anterior (si pasa, se usa el color de reserva que trae la tarjeta)
  const dedupeFlat = () => {
    let prev = '';
    document.querySelectorAll('#ProductGridContainer .w7-flat[data-w7-color]').forEach((f) => {
      if (f.dataset.w7Color === prev && f.dataset.w7AltSrc && f.dataset.w7AltColor !== prev) {
        const img = f.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = f.dataset.w7AltSrc; }
        [f.dataset.w7Variant, f.dataset.w7AltVariant] = [f.dataset.w7AltVariant, f.dataset.w7Variant];
        [f.dataset.w7Color, f.dataset.w7AltColor] = [f.dataset.w7AltColor, f.dataset.w7Color];
        delete f.dataset.w7AltSrc;
      }
      prev = f.dataset.w7Color;
    });
  };
  dedupeFlat();
  new MutationObserver(() => { clearTimeout(dedupeFlat.t); dedupeFlat.t = setTimeout(dedupeFlat, 150); }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  const liftRow = () => {
    const tb = document.querySelector('facets-topbar.collection__topbar');
    const box = document.querySelector('.collection-banner-section .banner__box');
    const t = box && box.querySelector('.banner__title');
    const row = tb && tb.querySelector('.facet-topbar');
    const html = document.documentElement;
    if (!tb || !t || !row) return;
    tb.style.marginTop = '';
    const on = innerWidth >= 1200 && !box.closest('.banner').querySelector('img, video, .banner__media');
    html.classList.toggle('w7-inline', on);
    if (!on) return;
    const a = t.getBoundingClientRect();
    const r = row.getBoundingClientRect();
    // 25-oct: si el título ocupa más de un renglón, los botones quedan abajo (si no, se pisan con el título)
    const lh = parseFloat(getComputedStyle(t).lineHeight) || parseFloat(getComputedStyle(t).fontSize) * 1.1;
    if (a.height > lh * 1.5) { html.classList.remove('w7-inline'); return; }
    const lift = (r.top + r.height / 2) - (a.top + a.height / 2);
    tb.style.marginTop = (parseFloat(getComputedStyle(tb).marginTop) - lift) + 'px';
  };
  liftRow();
  addEventListener('resize', () => { clearTimeout(liftRow.t); liftRow.t = setTimeout(liftRow, 150); });
  if (document.fonts) document.fonts.ready.then(liftRow);
})();


// 26-oct (Alan/Uri) · «¿Cuándo llega?» por código postal en el carrito y el mini carrito. Usa el mismo CP que la ficha
// (localStorage dlvrCP) y la misma zona que deliver-llega-hoy: CABA/GBA 1000–1925 = OCA Express; resto = express.
(() => {
  const get = () => { try { return localStorage.getItem('dlvrCP') || ''; } catch (e) { return ''; } };
  const set = (v) => { try { localStorage.setItem('dlvrCP', v); } catch (e) {} };
  const zona = (cp) => { const n = parseInt(cp, 10); return n >= 1000 && n <= 1925 ? 'hoy' : 'resto'; };
  const form = (box) => {
    box.innerHTML = '<div class="w7-ship-t">🚚 ¿Cuándo llega?</div><div class="w7-ship-f"><input type="tel" inputmode="numeric" maxlength="4" placeholder="Tu código postal (ej. 1414)" aria-label="Código postal"><button type="button">Calcular</button></div>';
    const i = box.querySelector('input');
    const go = () => { const v = (i.value || '').replace(/\D/g, ''); if (v.length !== 4) { i.classList.add('err'); return; } set(v); pintar(); };
    box.querySelector('button').addEventListener('click', go);
    i.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  };
  const pintar = () => {
    const cp = get();
    document.querySelectorAll('[data-w7-ship]').forEach((box) => {
      if (!cp) { if (!box.querySelector('input')) form(box); return; }
      const z = zona(cp);
      box.innerHTML = z === 'hoy'
        ? `<div class="w7-ship-t">🚚 <b>OCA Express:</b> sale en el próximo reparto y llega ese día o el siguiente día hábil</div><div class="w7-ship-s">Repartos de lunes a viernes · corte 12:00 · CP ${cp} · <button type="button" class="w7-ship-c">cambiar</button></div>`
        : `<div class="w7-ship-t">🚀 <b>Envío express a tu zona</b> con OCA o Correo Argentino</div><div class="w7-ship-s">Elegís el correo al pagar · CP ${cp} · <button type="button" class="w7-ship-c">cambiar</button></div>`;
      box.querySelector('.w7-ship-c').addEventListener('click', () => { form(box); const i = box.querySelector('input'); i.value = cp; i.focus(); });
    });
    const zip = document.querySelector('input[name="address[zip]"]');
    if (zip && cp && !zip.value) zip.value = cp;
  };
  pintar();
  document.addEventListener('w7:open', pintar, true);
  window.addEventListener('storage', (e) => { if (e.key === 'dlvrCP') pintar(); });
})();
